const indexData = [
    {
        "country": "Switzerland",
        "project": 100,
        "career": 81,
        "employ": 85,
        "rank": 1,
        "iso_code": "CHE",
        "ISO2": "CH",
    },
    {
        "country": "Singapore",
        "project": 100,
        "career": 61,
        "employ": 99,
        "rank": 2,
        "iso_code": "SGP",
        "ISO2": "SG",
    },
    {
        "country": "United States of America",
        "project": 89,
        "career": 75,
        "employ": 85,
        "rank": 3,
        "iso_code": "USA",
        "ISO2": "US",
    },
    {
        "country": "Australia",
        "project": 69,
        "career": 66,
        "employ": 77,
        "rank": 4,
        "iso_code": "AUS",
        "ISO2": "AU",
    },
    {
        "country": "Canada",
        "project": 66,
        "career": 74,
        "employ": 80,
        "rank": 5,
        "iso_code": "CAN",
        "ISO2": "CA",
    },
    {
        "country": "United Kingdom",
        "project": 62,
        "career": 58,
        "employ": 71,
        "rank": 6,
        "iso_code": "GBR",
        "ISO2": "GB",
    },
    {
        "country": "United Arab Emirates",
        "project": 78,
        "career": 51,
        "employ": 84,
        "rank": 7,
        "iso_code": "ARE",
        "ISO2": "AE",
    },
    {
        "country": "Austria",
        "project": 58,
        "career": 56,
        "employ": 69,
        "rank": 8,
        "iso_code": "AUT",
        "ISO2": "AT",
    },
    {
        "country": "New Zealand",
        "project": 61,
        "career": 54,
        "employ": 60,
        "rank": 8,
        "iso_code": "NZL",
        "ISO2": "NZ",
    },
    {
        "country": "Italy",
        "project": 53,
        "career": 61,
        "employ": 65,
        "rank": 9,
        "iso_code": "ITA",
        "ISO2": "IT",
    },
    {
        "country": "Hong Kong",
        "project": 85,
        "career": 52,
        "employ": 81,
        "rank": 10,
        "iso_code": "HKG",
        "ISO2": "HK",
    },
    {
        "country": "Latvia",
        "project": 73,
        "career": 59,
        "employ": 48,
        "rank": 11,
        "iso_code": "LVA",
        "ISO2": "LV",
    },
    {
        "country": "Malta",
        "project": 44,
        "career": 62,
        "employ": 58,
        "rank": 12,
        "iso_code": "MLT",
        "ISO2": "MT",
    },
    {
        "country": "Hungary",
        "project": 71,
        "career": 43,
        "employ": 49,
        "rank": 13,
        "iso_code": "HUN",
        "ISO2": "HU",
    },
    {
        "country": "Greece",
        "project": 48,
        "career": 44,
        "employ": 59,
        "rank": 14,
        "iso_code": "GRC",
        "ISO2": "GR",
    },
    {
        "country": "Portugal",
        "project": 41,
        "career": 50,
        "employ": 52,
        "rank": 14,
        "iso_code": "PRT",
        "ISO2": "PT",
    },
];


export {indexData};